export enum AddTeamType {
    TASK_TEAM       = 'TASK_TEAM',
    PROJECT_TEAM    = 'PROJECT_TEAM',
    WORKSPACE_TEAM  = 'WORKSPACE_TEAM',
} 